import { render, staticRenderFns } from "./IconDiscount.vue?vue&type=template&id=4086dd22&"
import script from "./IconDiscount.vue?vue&type=script&lang=js&"
export * from "./IconDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports